import { DOCUMENT, effect, inject, Injectable, signal } from '@angular/core';

export type ThemeMode = 'auto' | 'light' | 'dark';

const STORAGE_KEY = 'theme-mode';

@Injectable({
  providedIn: 'root',
})
export class Theme {
  private readonly document = inject(DOCUMENT);

  readonly mode = signal<ThemeMode>(this.readInitialMode());

  constructor() {
    effect(() => {
      const mode = this.mode();
      this.applyToDom(mode);
      this.persist(mode);
    });
  }

  setMode(mode: ThemeMode) {
    this.mode.set(mode);
  }

  /** Quick toggle between light/dark (ignores 'auto') */
  toggle() {
    this.setMode(this.mode() === 'dark' ? 'light' : 'dark');
  }

  /** Cycle: auto -> light -> dark -> auto */
  cycle() {
    const next: Record<ThemeMode, ThemeMode> = {
      auto: 'light',
      light: 'dark',
      dark: 'auto',
    };
    this.setMode(next[this.mode()]);
  }

  private applyToDom(mode: ThemeMode) {
    const root = this.document.documentElement;
    root.setAttribute('data-theme', mode);
    root.style.colorScheme = mode === 'auto' ? 'light dark' : mode;
  }

  private persist(mode: ThemeMode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {}
  }

  private readInitialMode(): ThemeMode {
    // try {
    //   const saved = localStorage.getItem(STORAGE_KEY) as ThemeMode | null;
    //   if (saved === 'auto' || saved === 'light' || saved === 'dark') return saved;
    // } catch {}
    return 'light';
    // return 'auto';
  }
}
